import { ToastInputSettings } from '@custom-types/core/app-toast-notifications.model';
import { createAction, props } from '@ngrx/store';

export const setAppToastNotification = createAction(
  '[Toast Notification] Set',
  props<{ toastSettings: ToastInputSettings }>(),
);
